<!--
@component
TeamsLayout

Route layout. Renders shared chrome around child routes.
-->

<script lang="ts">
  import { appState } from '$lib/stores/index.svelte';
  import { page } from '$app/state';

  let { data, children } = $props();

  // Set the active country for this route. Reading from `appState.teams` means we always reflect the freshest team object — including poller updates.
  $effect(() => {
    const team = appState.teams.getTeam(page.params.slug || '');
    appState.activeCountry = team ? [team] : [];
  });
</script>

{@render children()}
